import { useQuery } from '@tanstack/react-query';
import type { IFRiskSnapshot } from '../types/financiamento.types';
import { fetchRiskHistorico } from '../services/ifDataService';

export type { IFRiskSnapshot };

export function useIFRiskHistorico(contratoId: string | null, dias = 90) {
  return useQuery({
    queryKey: ['if-risk-historico', contratoId, dias],
    queryFn: async () => {
      if (!contratoId) return [];
      return (await fetchRiskHistorico(contratoId, dias)) as IFRiskSnapshot[];
    },
    enabled: !!contratoId,
  });
}
